// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dd-container[data-v-114deb20]{margin-left:2em;position:relative}select#industry[data-v-114deb20]{width:100%;height:auto;font:400 90% Open Sans,sans-serif;padding:10px;background-color:hsla(0,0%,100%,.2);-webkit-appearance:none;-moz-appearance:none;appearance:none;display:block;border-radius:7px;border:2px solid #6270c6}.fa-angle-down[data-v-114deb20]{bottom:6px;right:12px;font-size:200%;font-weight:900;color:#6270c6;position:absolute}", ""]);
// Exports
module.exports = exports;
